// extracted by mini-css-extract-plugin
export default {"playFavContainer":"style_playFavContainer__2izZ6","playFavContainer__top":"style_playFavContainer__top__N5cZm","playIcon":"style_playIcon__2ZRqx","favIcon":"style_favIcon__3P3SO"};